import { Component } from '@angular/core';

@Component({
  selector: 'app-page-no-longer-available',
  templateUrl: './page-no-longer-available.component.html',
})
export class PageNoLongerAvailableComponent {
  constructor() {}
}
